// @ts-nocheck
// export const EMPTY_FORM = {
//   personal: {
//     name: '',
//     email: '',
//     phone: '',
//     location: '',
//     linkedin: '',
//     github: '',
//     portfolio: '',
//     summary: '',
//     photo: null,   // base64 data URL
//   },
//   education: [
//     {
//       id: Date.now(),
//       school: '',
//       degree: '',
//       field: '',
//       gpa: '',
//       startYear: '',
//       endYear: '',
//       current: false,
//       courses: '',
//       honors: '',
//     },
//   ],
//   experience: [
//     {
//       id: Date.now() + 1,
//       company: '',
//       role: '',
//       location: '',
//       startDate: '',
//       endDate: '',
//       current: false,
//       bullets: '',
//     },
//   ],
//   projects: [
//     {
//       id: Date.now() + 2,
//       name: '',
//       tech: '',
//       link: '',
//       github: '',
//       description: '',
//     },
//   ],
//   skills: {
//     technical: '',
//     frameworks: '',
//     languages: '',
//     databases: '',
//     cloud: '',
//     soft: '',
//   },
//   certifications: [
//     {
//       id: Date.now() + 3,
//       name: '',
//       issuer: '',
//       date: '',
//       credentialId: '',
//     },
//   ],
//   achievements: '',
//   volunteering: '',
// };

// export const TEMPLATES = [
//   {
//     id: 'classic',
//     name: 'Classic',
//     description: 'Timeless professional look',
//     preview: '#1a365d',
//     accent: '#1a365d',
//     subAccent: '#2d5986',
//     fontFamily: "'Georgia', 'Times New Roman', serif",
//     headingFont: "'Georgia', serif",
//     style: 'traditional',
//   },
//   {
//     id: 'modern',
//     name: 'Modern',
//     description: 'Clean & contemporary',
//     preview: '#0f766e',
//     accent: '#0f766e',
//     subAccent: '#14b8a6',
//     fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
//     headingFont: "'Inter', sans-serif",
//     style: 'modern',
//   },
//   {
//     id: 'minimal',
//     name: 'Minimal',
//     description: 'Simple & impactful',
//     preview: '#18181b',
//     accent: '#18181b',
//     subAccent: '#52525b',
//     fontFamily: "'Helvetica Neue', Arial, sans-serif",
//     headingFont: "'Helvetica Neue', sans-serif",
//     style: 'minimal',
//   },
//   {
//     id: 'executive',
//     name: 'Executive',
//     description: 'Bold & authoritative',
//     preview: '#7c2d12',
//     accent: '#7c2d12',
//     subAccent: '#c2410c',
//     fontFamily: "'Palatino Linotype', 'Palatino', serif",
//     headingFont: "'Palatino Linotype', serif",
//     style: 'executive',
//   },
//   {
//     id: 'tech',
//     name: 'Tech',
//     description: 'For developers & engineers',
//     preview: '#1d4ed8',
//     accent: '#1d4ed8',
//     subAccent: '#3b82f6',
//     fontFamily: "'Inter', 'Segoe UI', sans-serif",
//     headingFont: "'JetBrains Mono', monospace",
//     style: 'tech',
//   },
// ];

// export const TABS = [
//   { id: 'personal', label: 'Personal Info', icon: 'personal' },
//   { id: 'education', label: 'Education', icon: 'education' },
//   { id: 'experience', label: 'Experience', icon: 'experience' },
//   { id: 'projects', label: 'Projects', icon: 'projects' },
//   { id: 'skills', label: 'Skills', icon: 'skills' },
//   { id: 'certifications', label: 'Certifications', icon: 'certifications' },
//   { id: 'extras', label: 'Extras', icon: 'extras' },
// ];

// export const ATS_TIPS = {
//   personal: {
//     title: 'ATS Tip: Contact Info',
//     tip: 'Use a professional email. Include LinkedIn & GitHub for tech roles. Avoid adding photos â€” ATS systems can\'t read them.',
//   },
//   education: {
//     title: 'ATS Tip: Education',
//     tip: 'Include your GPA if 3.0+. List relevant coursework that matches the job description keywords. Spell out degree names fully.',
//   },
//   experience: {
//     title: 'ATS Tip: Experience',
//     tip: 'Start each bullet with a strong action verb (Built, Developed, Increased). Add numbers wherever possible. Mirror keywords from the job posting.',
//   },
//   projects: {
//     title: 'ATS Tip: Projects',
//     tip: 'Projects are your portfolio as a student! Mention the problem solved, technologies used, and measurable outcome.',
//   },
//   skills: {
//     title: 'ATS Tip: Skills',
//     tip: 'Use exact technology names (e.g., "React.js" not "React framework"). Never use skill bars or ratings â€” ATS ignores them. Separate with commas.',
//   },
//   certifications: {
//     title: 'ATS Tip: Certifications',
//     tip: 'Include credential IDs for verification. AWS, Google Cloud, and Microsoft certifications are highly valued by ATS systems.',
//   },
//   extras: {
//     title: 'ATS Tip: Extras',
//     tip: 'List hackathon wins, leadership roles, and open source contributions. These show initiative beyond academics.',
//   },
// };

export const EMPTY_FORM = {
  personal: {
    name: "",
    email: "",
    phone: "",
    location: "",
    linkedin: "",
    github: "",
    portfolio: "",
    summary: "",
    photo: null, // base64 data URL
  },
  education: [
    {
      id: Date.now(),
      school: "",
      degree: "",
      field: "",
      gpa: "",
      percentage: "",
      startYear: "",
      endYear: "",
      current: false,
      courses: "",
      honors: "",
    },
  ],
  experience: [
    {
      id: Date.now() + 1,
      company: "",
      role: "",
      location: "",
      startDate: "",
      endDate: "",
      current: false,
      bullets: "",
    },
  ],
  projects: [
    {
      id: Date.now() + 2,
      name: "",
      tech: "",
      link: "",
      github: "",
      description: "",
    },
  ],
  skills: {
    technical: "",
    frameworks: "",
    languages: "",
    databases: "",
    cloud: "",
    soft: "",
  },
  certifications: [
    {
      id: Date.now() + 3,
      name: "",
      issuer: "",
      date: "",
      credentialId: "",
    },
  ],
  customSections: [],
};

export const TEMPLATES = [
  {
    id: "classic",
    name: "Classic",
    description: "Timeless professional serif look",
    accent: "#1a365d",
    fontFamily: "'Georgia', 'Times New Roman', serif",
    headingFont: "'Georgia', serif",
    style: "classic",
  },
  {
    id: "modern",
    name: "Modern",
    description: "Clean & contemporary sans-serif",
    accent: "#0f766e",
    fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
    headingFont: "'Inter', sans-serif",
    style: "modern",
  },
  {
    id: "minimal",
    name: "Minimal",
    description: "Simple, stark & impactful",
    accent: "#18181b",
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    headingFont: "'Helvetica Neue', sans-serif",
    style: "minimal",
  },
  {
    id: "executive",
    name: "Executive",
    description: "Bold, authoritative & refined",
    accent: "#7c2d12",
    fontFamily: "'Palatino Linotype', 'Palatino', serif",
    headingFont: "'Palatino Linotype', serif",
    style: "executive",
  },
  {
    id: "tech",
    name: "Tech",
    description: "Developer-focused mono headings",
    accent: "#1d4ed8",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    headingFont: "'JetBrains Mono', monospace",
    style: "tech",
  },
  {
    id: "sidebar",
    name: "Sidebar",
    description: "Two-column with colored left panel",
    accent: "#6d28d9",
    fontFamily: "'Inter', sans-serif",
    headingFont: "'Inter', sans-serif",
    style: "sidebar",
  },
  {
    id: "elegant",
    name: "Elegant",
    description: "Centered header with divider lines",
    accent: "#b45309",
    fontFamily: "'Playfair Display', Georgia, serif",
    headingFont: "'Playfair Display', serif",
    style: "elegant",
  },
  {
    id: "bold",
    name: "Bold",
    description: "Strong header band, high contrast",
    accent: "#0f172a",
    fontFamily: "'Inter', sans-serif",
    headingFont: "'Inter', sans-serif",
    style: "bold",
  },
  {
    id: "creative",
    name: "Creative",
    description: "Accent left border, airy layout",
    accent: "#059669",
    fontFamily: "'Inter', sans-serif",
    headingFont: "'Inter', sans-serif",
    style: "creative",
  },
  {
    id: "compact",
    name: "Compact",
    description: "Dense, information-rich layout",
    accent: "#dc2626",
    fontFamily: "'Arial', sans-serif",
    headingFont: "'Arial', sans-serif",
    style: "compact",
  },
];

export const FONT_STYLES = [
  {
    id: "template",
    name: "Template default",
    description: "Use each template's original typography",
    fontFamily: null,
    headingFont: null,
    pdfFonts: null,
  },
  {
    id: "modern-sans",
    name: "Modern Sans",
    description: "Clean and readable",
    fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
    headingFont: "'Inter', 'Helvetica Neue', Arial, sans-serif",
    pdfFonts: { body: "Helvetica", heading: "Helvetica" },
  },
  {
    id: "classic-serif",
    name: "Classic Serif",
    description: "Traditional resume feel",
    fontFamily: "'Georgia', 'Times New Roman', serif",
    headingFont: "'Georgia', 'Times New Roman', serif",
    pdfFonts: { body: "Times-Roman", heading: "Times-Roman" },
  },
  {
    id: "executive-serif",
    name: "Executive Serif",
    description: "Formal and refined",
    fontFamily: "'Palatino Linotype', Palatino, Georgia, serif",
    headingFont: "'Palatino Linotype', Palatino, Georgia, serif",
    pdfFonts: { body: "Times-Roman", heading: "Times-Roman" },
  },
  {
    id: "mono-tech",
    name: "Mono Tech",
    description: "Crisp technical style",
    fontFamily: "'JetBrains Mono', 'Courier New', monospace",
    headingFont: "'JetBrains Mono', 'Courier New', monospace",
    pdfFonts: { body: "Courier", heading: "Courier" },
  },
  {
    id: "compact-sans",
    name: "Compact Sans",
    description: "Dense and ATS-friendly",
    fontFamily: "Arial, 'Helvetica Neue', sans-serif",
    headingFont: "Arial, 'Helvetica Neue', sans-serif",
    pdfFonts: { body: "Helvetica", heading: "Helvetica" },
  },
  {
    id: "editorial",
    name: "Editorial",
    description: "Elegant display headings",
    fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
    headingFont: "'Playfair Display', Georgia, serif",
    pdfFonts: { body: "Helvetica", heading: "Times-Roman" },
  },
];

export const TABS = [
  { id: "personal", label: "Personal Info", icon: "personal" },
  { id: "education", label: "Education", icon: "education" },
  { id: "experience", label: "Experience", icon: "experience" },
  { id: "projects", label: "Projects", icon: "projects" },
  { id: "skills", label: "Skills", icon: "skills" },
  { id: "certifications", label: "Certifications", icon: "certifications" },
  { id: "custom", label: "Custom Sections", icon: "custom" },
  { id: "templates", label: "Templates", icon: "templates" },
];

export const ATS_TIPS = {
  personal: {
    title: "ATS Tip: Contact Info",
    tip: "Use a professional email. Include LinkedIn & GitHub for tech roles. Avoid adding photos â€” ATS systems can't read them.",
  },
  education: {
    title: "ATS Tip: Education",
    tip: "Include your GPA if 3.0+. List relevant coursework that matches the job description keywords. Spell out degree names fully.",
  },
  experience: {
    title: "ATS Tip: Experience",
    tip: "Start each bullet with a strong action verb (Built, Developed, Increased). Add numbers wherever possible. Mirror keywords from the job posting.",
  },
  projects: {
    title: "ATS Tip: Projects",
    tip: "Projects are your portfolio as a student! Mention the problem solved, technologies used, and measurable outcome.",
  },
  skills: {
    title: "ATS Tip: Skills",
    tip: 'Use exact technology names (e.g., "React.js" not "React framework"). Never use skill bars or ratings â€” ATS ignores them. Separate with commas.',
  },
  certifications: {
    title: "ATS Tip: Certifications",
    tip: "Include credential IDs for verification. AWS, Google Cloud, and Microsoft certifications are highly valued by ATS systems.",
  },
  custom: {
    title: "ATS Tip: Custom Sections",
    tip: "Use Custom Sections for anything not covered by the standard tabs — Achievements, Volunteering, Publications, Patents, Languages, Hobbies, Conference Talks, etc. Keep titles clear and add a bullet per line.",
  },
};
